
import { useState } from 'react';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navItems = [
    { path: '/ranking', label: 'ランキング' },
    { path: '/comparison', label: '比較一覧' },
    { path: '/free', label: '年会費無料' },
    { path: '/student', label: '学生向け' },
    { path: '/instant', label: '即日発行' },
    { path: '/highreturn', label: '高還元率' },
  ];

  return (
    <header className="bg-white border-b border-gray-200 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <a href="/" className="flex items-center cursor-pointer">
            <h1 className="text-2xl font-bold text-[#003366]">クレカ比較ナビ</h1>
          </a>

          <nav className="hidden md:flex items-center gap-8">
            {navItems.map((item) => (
              <a
                key={item.path}
                href={item.path}
                className="font-medium text-gray-700 hover:text-[#003366] transition-colors cursor-pointer whitespace-nowrap"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            aria-label="メニュー"
          >
            {/* Using a self‑closing <i> tag to avoid JSX parsing issues */}
            <i
              className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl text-gray-700`}
            />
          </button>
        </div>

        {isMenuOpen && (
          <nav className="md:hidden mt-4 pb-4 border-t border-gray-200 pt-4">
            <div className="flex flex-col gap-4">
              {navItems.map((item) => (
                <a
                  key={item.path}
                  href={item.path}
                  className="font-medium text-gray-700 hover:text-[#003366] transition-colors cursor-pointer"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </nav>
        )}
      </div>
    </header>
  );
}
